// extracted by mini-css-extract-plugin
export default {"no-data-wrap":"noData_no-data-wrap__n6W0+"};